import {createAction} from '@reduxjs/toolkit'
import {Dispatch} from 'redux'
import {getEventListPageUrl} from '../services/navigation'
import {createAsyncAction} from '../services/redux-toolkit'
import {CommonStoreExtraArgs, GetCommonState} from '../types/state'
import {getLanguage, getLocale, getTimezone, isEditor, isMobile, isPreview, isSite} from '../utils/wix-code-api'

export const SET_BASE_ENVIRONMENT_OLD = 'SET_BASE_ENVIRONMENT_OLD'

export const setBaseEnvironmentOld =
  () =>
  async (dispatch: Dispatch, _: GetCommonState, {wixCodeApi}: CommonStoreExtraArgs) => {
    const homePageUrl = wixCodeApi.location.baseUrl
    const eventListPageUrl = await getEventListPageUrl(wixCodeApi)

    dispatch({
      type: SET_BASE_ENVIRONMENT_OLD,
      payload: {
        seo: wixCodeApi.seo.isInSEO(),
        locale: getLocale(wixCodeApi) || 'en',
        language: getLanguage(wixCodeApi),
        timezone: getTimezone(wixCodeApi),
        mobile: isMobile(wixCodeApi),
        editor: isEditor(wixCodeApi),
        preview: isPreview(wixCodeApi),
        site: isSite(wixCodeApi),
        eventListPageUrl: eventListPageUrl?.url ?? homePageUrl,
        eventListPageRelativeUrl: eventListPageUrl?.relativeUrl,
        homePageUrl,
      },
    })
  }

export const setBaseEnvironment = createAsyncAction('SET_BASE_ENVIRONMENT', async (_, {extra: {wixCodeApi}}) => {
  const homePageUrl = wixCodeApi.location.baseUrl
  const eventListPageUrl = await getEventListPageUrl(wixCodeApi)

  return {
    seo: wixCodeApi.seo.isInSEO(),
    locale: getLocale(wixCodeApi) || 'en',
    language: getLanguage(wixCodeApi),
    timezone: getTimezone(wixCodeApi),
    mobile: isMobile(wixCodeApi),
    editor: isEditor(wixCodeApi),
    preview: isPreview(wixCodeApi),
    site: isSite(wixCodeApi),
    eventListPageUrl: eventListPageUrl?.url ?? homePageUrl,
    eventListPageRelativeUrl: eventListPageUrl?.relativeUrl,
    homePageUrl,
  }
})

export const setFormFactor = createAction<string>('SET_FORM_FACTOR')
